
import { Tbl_legaEdit } from './tbl_legaEdit';
import { Tbl_legaList } from './tbl_legaList';
import { Tbl_legaShow } from './tbl_legaShow';
import { Tbl_legaCreate } from './tbl_legaCreate';
import { LegaRedirect } from './LegaRedirect';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: LegaRedirect, // Reindirizza alla pagina personalizzata
    edit: Tbl_legaEdit,
    show: Tbl_legaShow,
    create: Tbl_legaCreate,
    icon: EmojiEventsIcon
};
            